import { j as p } from "../../jsx-runtime-82a9ddf6.js";
import { R as u } from "../../ReactCodeInput-cc430180.js";
const x = ({ value: t, name: o, type: r = "number", className: e = "", fields: n = 8, onChange: m }) => /* @__PURE__ */ p.jsx(
  u,
  {
    type: r,
    fields: n,
    onChange: m,
    value: t,
    className: e,
    name: o,
    inputMode: "numeric"
  }
);
export {
  x as CodeInput
};
